module.exports = __webpack_public_path__ + "img/yishi2.2831f146.jpg";